import { Link as LinkLi } from '@material-ui/core';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { hasEnabledFeature, hasValue, isInsuracePortalUser } from 'globalutils/fmUtils';
import React, { lazy, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as LinkDom } from 'react-router-dom';
import { checkCamera } from '../../utils';
import { getConfig } from './config';
import ViewMoreText from 'globalcomponents/ViewMoreText';
import { checkServiceProvider } from './serviceProviderConfig';

const LiveStreaming = lazy(() => import('../LiveStreaming'));
const StreamingStatus = lazy(() => import('../StreamingStatus'));
const DeleteConfirm = lazy(() => import('../DeleteConfirm'));
const layout = window?.$environment?.CURRENT_LAYOUT;
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;

export default function VehicleList({
  vehicles,
  getDrivers,
  videoUrl,
  fetchLiveUrl,
  clearFetchLiveUrlTimeout,
  callback,
  cameraStatus,
  fetchCameraStatus,
  apiStatus,
  fetchVehicles,
  handleDeleteAlert,
  setPagination,
  pagination,
}) {
  const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
  const i18n = useTranslation();
  const insuracePortalUserRole = isInsuracePortalUser();
  const [driverData, setDriverData] = useState(null);

  const hasUserListApiStatus = hasValue(apiStatus.status, 'api', fetchVehicles);
  const information =
    hasUserListApiStatus && hasUserListApiStatus.errorMessage ? (
      <Message type="error" message={i18n.t(hasUserListApiStatus.errorMessage)} />
    ) : (
      i18n.t('common.tableEmptyMessage')
    );

  const hasCamera = useMemo(() => {
    return checkCamera({ vehicles });
  }, [vehicles]);

  const columns = useMemo(() => {
    return getConfig({ insuracePortalUserRole, hasCamera }).tableColumns;
  }, [hasCamera, insuracePortalUserRole]);

  const renderEditIcon = (row) => (
    <LinkLi component={LinkDom} to={pageUrls.editVehicle.replace(':id', row.id)} className="normalLink">
      <Icon tooltip={i18n.t('common.edit')} src={mediaUrls?.editSvg} />
    </LinkLi>
  );

  const renderLiveStreamingIcon = (row) =>
    hasCamera ? (
      <LiveStreaming
        {...{
          row,
          videoUrl,
          fetchLiveUrl,
          clearFetchLiveUrlTimeout,
          callback,
        }}
      />
    ) : null;

  const renderStreamingStatusIcon = (row) =>
    hasCamera ? (
      <StreamingStatus
        {...{
          row,
          cameraStatus,
          fetchCameraStatus,
          apiStatus,
          fetchVehicles,
        }}
      />
    ) : null;

  const renderDeleteIcon = (row) => <DeleteConfirm {...{ row, handleDeleteAlert, callback }} />;

  // Define core actions
  const baseActions = [
    {
      icon: renderEditIcon,
    },
  ];

  const cameraActions = hasEnabledFeature('cameraIntegrationEnabled')
    ? [{ icon: renderLiveStreamingIcon }, { icon: renderStreamingStatusIcon }]
    : [];

  const deleteActions = checkServiceProvider('vehicleList_deleteActions', SERVICE_PROVIDER) ? [{ icon: renderDeleteIcon }] : [];

  const restrictedActions = checkServiceProvider('vehicleList_restrictedActions', SERVICE_PROVIDER, false)
    ? [...baseActions, ...cameraActions]
    : [...baseActions, ...deleteActions, ...cameraActions];

  const openDriverNamePopupModal = (type, res, req) => {
    setDriverData({ req, res });
  };

  const openDriverNamePopup = (drivers, unit_id) => {
    getDrivers({
      apiId: 'getDriversVehiclePage',
      data: {
        driverIds: drivers,
      },
      callback: openDriverNamePopupModal,
      unit_id: unit_id,
    });
  };

  const generateRows = () => {
    const updatedList = vehicles.vehicleFilteredList.map((item, index) => {
      item.driversList = (
        <div className="driverNamePopup" onClick={() => openDriverNamePopup(item.drivers, item.unit_id)}>
          {item.driversCount}
        </div>
      );
      item.model = <ViewMoreText text={item?.model || ''} />;
      item.manufact = <ViewMoreText text={item?.manufact || ''} />;
      return item;
    });
    return updatedList;
  };

  const getModalConent = () => {
    const { req, res } = driverData;
    let str = res?.response;
    let str_array = str.split(',');
    let array = [];
    for (var i = 0; i < str_array.length; i++) {
      array.push(str_array[i]);
    }
    return {
      content: () => {
        return (
          <div className="driverNameModal">
            <div className="headWrapper">
              {i18n.t('DRIVERS OF')} {req?.unit_id}
            </div>
            <ul>
              {array.map((items, index) => {
                return <li key={index}>{items}</li>;
              })}
            </ul>
          </div>
        );
      },
    };
  };

  return (
    <>
      <Table
        type="client"
        defaultSortBy={{ sortBy: 'unit_id', order: 'asc' }}
        title=""
        columns={columns}
        data={generateRows()}
        emptyMessage={information}
        itemsPerPage={10}
        actions={restrictedActions}
        defaultSort={'full_name'}
        i18n={i18n}
        pageinationReset={pagination}
        pagenationClicked={(e) => setPagination(!e)}
      />
      {driverData && (
        <Modal
          open={true}
          setOpen={setDriverData}
          data={getModalConent()}
          deletePopup
          withCloseIcon
          alignItemsLeft
          width={'260px'}
        />
      )}
    </>
  );
}
